var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCross33(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26.45 26.45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cross-1",
    d: "M17.3,13.23l8.3-8.3c1.13-1.13,1.13-2.95,0-4.08s-2.95-1.13-4.08,0l-8.3,8.3L4.92.84C3.8-.28,1.97-.28.84.84-.28,1.97-.28,3.8.84,4.92l8.3,8.3L.84,21.53c-1.13,1.13-1.13,2.95,0,4.08,1.13,1.13,2.95,1.13,4.08,0l8.3-8.3,8.3,8.3c1.13,1.13,2.95,1.13,4.08,0s1.13-2.95,0-4.08l-8.3-8.3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross33);
export default __webpack_public_path__ + "static/media/cross-33.4ca9c846b68fd05edf8c18c0df265d13.svg";
export { ForwardRef as ReactComponent };